import { z } from 'zod';
import { SanityDocumentSchema, SanityReferenceSchema } from '../sanity';
import { NewsSectionSchema, SanityComponentUnion } from '../components';
import { SEOSchema } from '../shared/SEO';
import { NewsCollectionPageHeader } from './NewsCollectionPageHeader';
import { EntityType } from '$lib/sanity/types';

export const NewsLandingPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.NewsLandingPage),
  header: NewsCollectionPageHeader,
  components: z
    .array(z.union([z.lazy(() => SanityComponentUnion), SanityReferenceSchema]))
    .nullish()
    .default([]),
  sections: z
    .array(z.lazy(() => NewsSectionSchema))
    .nullish()
    .default([]),
  seoAttributes: SEOSchema.nullish()
});

export type NewsLandingPage = z.infer<typeof NewsLandingPageSchema>;
